import React from "react";
import { formatDate, debug, download } from "utils";
export default function AdminFormalityBillingCard({ order }) {
  if (!order) return null;
  const isPaid = order.orderPaymentStatus === "complete";
  const hasInvoice = !!order.orderPDFFilename;
  return (
    <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
        <strong>Facturation</strong>

        <span
          className={[
            "badge",
            isPaid ? "bg-success" : "bg-warning text-dark",
          ].join(" ")}
        >
          {isPaid ? 'Réglée' : 'Non réglée'}
        </span>
      </div>
      <div className="card-body">
        {/* INFOS COMMANDE */}
        <table className="table table-sm mb-3">
          <tbody>
            <tr>
              <th className="text-muted">Commande</th>
              <td>#{order.orderRef}</td>
            </tr>
            <tr>
              <th className="text-muted">Date</th>
              <td>{formatDate(order.orderDate)}</td>
            </tr>
            <tr>
              <th className="text-muted">Total HT</th>
              <td>{order.orderTotalPriceET} €</td>
            </tr>
            <tr>
              <th className="text-muted">TVA ({order.orderVATRate}%)</th>
              <td>{order.orderVATAmount} €</td>
            </tr>
            <tr>
              <th className="text-muted">Total TTC</th>
              <td><strong>{order.orderTotalPriceIT} €</strong></td>
            </tr>
            <tr>
              <th className="text-muted">Payé</th>
              <td>{order.orderTotalPaid} €</td>
            </tr>
            <tr>
              <th className="text-muted">Solde</th>
              <td className={order.orderBalance > 0 ? "text-danger" : "text-primary"}>
                {order.orderBalance} €
              </td>
            </tr>
          </tbody>
        </table>
        {/* PAIEMENTS */}
        {Array.isArray(order.payments) && order.payments.length > 0 && (
          <>
            <h6 className="text-muted">Paiements</h6>
            <table className="table table-sm mb-3">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Mode</th>
                  <th className="text-end">Montant</th>
                </tr>
              </thead>
              <tbody>
                {order.payments.map(p => (
                  <tr key={p.payId}>
                    <td>{formatDate(p.payCreatedAt)}</td>
                    <td>{p.payMode}</td>
                    <td className="text-end">{p.payAmount} €</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
        {/* ACTIONS */}
        {hasInvoice && <div className="text-end">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => {
              { download(`/admin/order/${order.orderId}/invoice/download`) }
            }}
          >
            Télécharger la facture
          </button>
        </div>
        }
      </div>
      {debug(order, false)}
    </div>
  );
}
